import React, { useState, useRef, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import ReactCountryFlag from 'react-country-flag';
import '../styles/LanguageSwitcher.css';
import { LOCALES as LOCALES_IMPORTED } from '../i18n/config';

// Guard against an incomplete test mock of `../i18n/config` that omits the
// LOCALES export (the real module always provides it). Falls back to a minimal
// English-only list so the switcher renders instead of crashing.
const LOCALES = LOCALES_IMPORTED && LOCALES_IMPORTED.length
  ? LOCALES_IMPORTED
  : [{ code: 'en', englishName: 'English', nativeName: 'English', flag: 'US', dir: 'ltr' }];

const LanguageSwitcher = () => {
  const { i18n } = useTranslation();
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);
  const currentLanguage = i18n.language.split('-')[0]; // Handle 'en-US' -> 'en'
  const currentLang = LOCALES.find((lang) => lang.code === currentLanguage) || LOCALES[0];

  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng);
    setIsOpen(false);
  };

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    if (isOpen) {
      document.addEventListener('mousedown', handleClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isOpen]);

  return (
    <div className="language-switcher" ref={dropdownRef}>
      <div className="language-button-wrapper">
        <button
          className="language-button"
          onClick={() => setIsOpen(!isOpen)}
          aria-label="Select language"
          aria-expanded={isOpen}
        >
          <div className="language-flag-display">
            <ReactCountryFlag
              countryCode={currentLang.flag}
              svg
              style={{
                width: '1.5em',
                height: '1.5em',
              }}
              title={currentLang.nativeName}
            />
          </div>
        </button>

        {isOpen && (
          <div className="language-dropdown" dir={currentLang.dir === 'rtl' ? 'rtl' : 'ltr'}>
            {LOCALES.map((lang) => (
              <button
                key={lang.code}
                className={`language-option ${currentLanguage === lang.code ? 'active' : ''}`}
                onClick={() => changeLanguage(lang.code)}
                dir={lang.dir}
              >
                <ReactCountryFlag
                  countryCode={lang.flag}
                  svg
                  style={{
                    width: '1.2em',
                    height: '1.2em',
                    marginRight: '0.5rem',
                  }}
                />
                <span>{lang.nativeName}</span>
              </button>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default LanguageSwitcher;

